import Home from "../pages/Home/Home/Home";
import Quote from "../pages/Quote";
import SuccessPage from "../pages/Quote/SuccessPage";
// import QuoteCommercial from "../pages/QuoteCommercial";
// import QuoteResidential from "../pages/QuoteResidential";

export let navbar = [
  {
    id: 1,
    title: "Home",
    element: <Home />,
    path: "/",
    isPrivate: false,
    hidden: false,
  },
  {
    id: 2,
    title: "Quote",
    element: <Quote />,
    path: "/quote",
    isPrivate: false,
    hidden: false,
  },
  {
    id: 2,
    title: "Success sended form",
    element: <SuccessPage />,
    path: "/quote/success",
    isPrivate: false,
    hidden: false,
  },
  // {
  //   id: 3,
  //   title: "Quote",
  //   element: <QuoteCommercial />,
  //   path: "/quote/commercial",
  //   isPrivate: false,
  //   hidden: false,
  // },
  // {
  //   id: 4,
  //   title: "Quote",
  //   element: <QuoteResidential />,
  //   path: "/quote/residential",
  //   isPrivate: false,
  //   hidden: false,
  // },
];
